module.exports = "/virtual-football/img/video/video-jackpot.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/video-jackpot.png
// module id = 312
// module chunks = 6